export default "__VITE_ASSET___uwo68aj__"